// Форматирует участника этапа из backend document_flow.
// Backend знает юридическую роль шага, а фронт только показывает её человеку.
export function edoDocumentFlowParticipantLabel(participant) {
  if (!participant) return "";

  const label = participant.label || participant.role || "Участник";
  const name = participant.name || "не указан";
  const details = [
    participant.inn ? `ИНН ${participant.inn}` : "",
    participant.kpp ? `КПП ${participant.kpp}` : "",
  ].filter(Boolean);
  const suffix = details.length ? `, ${details.join(", ")}` : "";

  return `${label}: ${name}${suffix}`;
}

export function edoDocumentFlowParticipantTitle(participant) {
  return participant ? "Участник этапа" : "";
}

// Короткая подпись для линии этапов: полные реквизиты остаются в tooltip и деталях
export function edoDocumentFlowParticipantTimelineLabel(participant) {
  if (!participant) return "";

  const label = participant.label || participant.role || "Участник";
  const name = participant.name || "не указан";

  return `${label}: ${name}`;
}
